export default __webpack_public_path__ + "static/media/chemical.46a5b858.png";